import React from 'react';
import PortfolioProject from "./projects/portfolioProject.jsx";
import Projects from "./projects/projects.jsx";
import ExcelAddin from './projects/excelAddin.jsx';
import DefiVectorEngine from './projects/defiVectorEngine.jsx';
import ChartingService from './projects/chartingService.jsx';
import { Route, Routes } from "react-router-dom";
import AuthenticationService from './projects/authenticationService.jsx';

const ProjectsPage = () => {

  return (
    <div className="app">
      <div className="projects-page">
        <Routes>
          <Route index element={<Projects />} />
          <Route path="/portfolio" element={<PortfolioProject />} />
          <Route path="/excelAddin" element={<ExcelAddin />} />
          <Route path="/authenticationService" element={<AuthenticationService />} />
          <Route path="/defiVectorEngine" element={<DefiVectorEngine />} />
          <Route path="/chartingService" element={<ChartingService />} />
        </Routes>
      </div>
    </div>
  );
};

export default ProjectsPage;
